import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { PracticeFeeApiActions } from "../actions/action-index";
import { PracticeFee } from "./practice-fee";

export const featureKey = "practiceFees";

export type PracticeFeeState = EntityState<PracticeFee>

export const adapter = createEntityAdapter<PracticeFee>({
  selectId: (fee) => fee.id,
  sortComparer: (a, b) => (a.sortOrder > b.sortOrder ? 1 : -1),
});

export const initialState: PracticeFeeState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(PracticeFeeApiActions.loadSuccess, (state, { practiceFees }) =>
    adapter.setAll(
      practiceFees.map((f) => ({
        ...f,
        amount: +f.amount,
      })),
      state
    )
  )
);
